import Phaser from "phaser";
import DropShadowPipelinePlugin from "phaser3-rex-plugins/plugins/dropshadowpipeline-plugin";
import OutlinePipelinePlugin from "phaser3-rex-plugins/plugins/outlinepipeline-plugin";
import UIPlugin from "phaser3-rex-plugins/templates/ui/ui-plugin";
import { ScrollablePanel } from "phaser3-rex-plugins/templates/ui/ui-components";
import GrayScalePipelinePlugin from "phaser3-rex-plugins/plugins/grayscalepipeline-plugin";
import ContainerLitePlugin from "phaser3-rex-plugins/plugins/containerlite-plugin";

import BootScene from "./BootScene";
import MainScene from "./MainScene";
import Pqp from "../../3x1010/Pqp";
import Locale from "../../3x1010/Locale";
import Meta from "./meta";

export default class Tracking {
  constructor(appConfig) {
    this.appConfig = appConfig;
    Tracking.appConfig = appConfig;

    if (!appConfig.aggregates) {
      //appConfig.aggregates = "/data/hts/SPORTINGTORINO/2T_0495aaed02b241569e1bdcf32beb6e47/aggregates.json";
      //appConfig.aggregates = "/data/hts/SPORTINGTORINO/2T_1916746e5ff84af4b90aef6a843efda0/aggregates.json";
    }

    Tracking.FILES = []; //];
    for (let x = 0; x < appConfig.resources.length; x++) {
      //Tracking.FILES.push(appConfig.resources[x].boundingBoxUrl, appConfig.resources[x].kpts2dUrl, appConfig.phasesUrl, appConfig.performUrl, appConfig.resources[x].kpts3dUrl, appConfig.statsUrl);
      Tracking.FILES.push(null, appConfig.resources[x].kpts2dUrl, appConfig.phasesUrl, appConfig.ball_velocity, appConfig.resources[x].kpts3dUrl, appConfig.indicators, appConfig.aggregates);
    }
    if (Tracking.DEBUG_PAOLO) {
      for (let x = 0; x < Tracking.FILES.length; x++) {
        Tracking.FILES[x] = Pqp.safeReplace(Tracking.FILES[x], "2T_bcbe8b8555174a6cacc7a832c5fa4550", "paolotest");
      }
    }

    //"2T_bcbe8b8555174a6cacc7a832c5fa4550"

    //debugger;
  }

  init() {
    this.loadIndex = 0;
    Tracking.data = [];

    this.loadNextJson();
  }

  loadNextJson() {
    //debugger;
    if (this.loadIndex < Tracking.FILES.length) {
      //console.log(this.loadIndex + " " + Tracking.FILES[this.loadIndex]);
      if (Tracking.FILES[this.loadIndex]?.indexOf("kpts_3d") >= 0) {
        Tracking.URL_KPTS_3D = Tracking.FILES[this.loadIndex];
        this.jsonLoaded(true, []);
      } else {
        this.loadJson(Tracking.FILES[this.loadIndex]);
      }
    } else {
      const tmp = [];
      let n = 0;
      for (let x = 0; x < Tracking.data.length; x += 7) {
        tmp.push({
          camid: this.appConfig.resources[n].camid,
          camdesc: this.appConfig.resources[n].camdesc,
          leftSide: this.appConfig.resources[n].leftSide,
          cached: false,
          url: this.appConfig.resources[n].videoUrl,
          aggregates: Tracking.data[x + 6],
          data: [Tracking.data[x], Tracking.data[x + 1], Tracking.data[x + 2], Tracking.data[x + 3], Tracking.data[x + 4], Tracking.data[x + 5]],
        });
        n++;
      }

      if (Tracking.DEBUG_PAOLO) {
        for (let x = 0; x < tmp.length; x++) {
          tmp[x].url = Pqp.safeReplace(tmp[x].url, "2T_bcbe8b8555174a6cacc7a832c5fa4550", "paolotest");
        }
      }

      Tracking.data = {
        layout3d: this.appConfig.layout3d,
        selected: this.appConfig.selected,
        version: "v1.0", //this.appConfig.version,
        videos: tmp,
      };

      console.log(Tracking.data);
      //debugger;

      setTimeout(this.loadResources.bind(this), 1000);
    }
  }

  loadResources() {
    const url = "/assets_static/indicators/indicators_meta.json";
    // Carica il json
    fetch(url, {
      headers: {
        "Content-Type": "application/json; charset=utf-8",
      },
      method: "GET",
    })
      .then((response) => response.json())
      .then((data) => {
        Meta.indicators = data;
        this.loadLabels();
      })
      .catch((error) => {
        console.error("Error loading indicators meta:", error);
      });
  }

  loadLabels() {
    const url = "/assets_static/player_labels/labels.json";
    // Carica il json
    fetch(url, {
      headers: {
        "Content-Type": "application/json; charset=utf-8",
      },
      method: "GET",
    })
      .then((response) => response.json())
      .then((data) => {
        //TheApp.Locale = "en-GB";
        console.log("Labels loaded:", TheApp.Locale);
        //Locale.init(data.labels, "en-GB"); // TheApp.Locale);
        Locale.init(data.labels, TheApp.Locale);
        console.log(Locale.g("Version"));
        this.createApp();
      })
      .catch((error) => {
        console.error("Error loading labels:", error);
      });
  }

  loadJson(file) {
    // query string
    const url = file;
    const method = "GET";
    const qs = "";
    const rq = null;
    const callback = this.jsonLoaded.bind(this);
    if (file) {
      fetch(`${url}${qs}`, {
        headers: {
          "Content-Type": "application/json; charset=utf-8",
        },
        method,
        body: method !== "GET" && rq ? JSON.stringify(rq) : null,
      })
        .then((response) => response.json())
        .then((data) => {
          if (callback) {
            callback.call(null, true, data);
          }
        })
        .catch((error) => {
          if (callback) {
            callback.call(null, false, error);
          }
        });
    } else {
      //callback.call(null, true, []);
      this.jsonLoaded(true, []);
    }
  }

  jsonLoaded(status, data) {
    this.loadIndex++;
    if (status === false) {
      Tracking.data.push([]);
    } else {
      Tracking.data.push(data);
    }
    this.loadNextJson();
  }

  createApp() {
    console.log(Tracking.data);
    //debugger;
    this.patchJsonStruct();
    //console.log(Tracking.data);
    const config = {
      type: Phaser.AUTO,
      width: Tracking.WIDTH,
      height: Tracking.HEIGHT,
      backgroundColor: "#000049",
      parent: "video-holder",
      pixelArt: false,
      scene: [BootScene],
      physics: {
        default: "arcade",
        arcade: {
          debug: false,
          gravity: { y: 0 },
        },
      },
      scale: {
        parent: "video-holder",
        fullscreenTarget: "video-holder",
        mode: Phaser.Scale.FIT,
        autoCenter: Phaser.Scale.CENTER_HORIZONTALLY,
        // Maximum size
        max: {
          width: Tracking.WIDTH,
          height: Tracking.HEIGHT,
        },
        zoom: 1,
      },
      //pipeline: [DropShadowPostFx],
      plugins: {
        global: [
          {
            key: "rexDropShadowPipeline",
            plugin: DropShadowPipelinePlugin,
            start: true,
          },
          {
            key: "rexOutlinePipeline",
            plugin: OutlinePipelinePlugin,
            start: true,
          },
          {
            key: "rexGrayScalePipeline",
            plugin: GrayScalePipelinePlugin,
            start: true,
          },
          {
            key: "rexContainerLitePlugin",
            plugin: ContainerLitePlugin,
            start: true,
          },
          // ...
        ],
        scene: [
          {
            key: "rexUI",
            plugin: UIPlugin,
            mapping: "rexUI",
          },
        ],
      },
    };

    //debugger;
    this.game = new Phaser.Game(config);
    this.game.events.on("ready", this.onGameReady.bind(this));
  }

  onGameReady() {
    var canvas = this.game.canvas;

    canvas.addEventListener(
      "wheel",
      function (event) {
        if (!MainScene.that) {
          event.preventDefault(); // Previene lo scrolling della pagina
          event.stopPropagation(); // Ferma la propagazione dell'evento
        }

        if (MainScene.that.statusReport === 1) {
          event.preventDefault(); // Previene lo scrolling della pagina
          event.stopPropagation(); // Ferma la propagazione dell'evento
        }
      },
      { passive: false }
    ); // Imposta passive a false per permettere il preventDefault
  }

  patchJsonStruct() {
    const a = Tracking.data.videos;
    //console.log(Tracking.data);
    /*for (let x = 0; x < a.length; x++) {
      this.fixStats(a[x]);
    }*/

    for (let x = 0; x < a.length; x++) {
      this.fixColpi(a[x]);
    }

    for (let x = 0; x < a.length; x++) {
      this.fixAggregates(a[x].aggregates, a[x].data[2], a[x]);
    }
  }

  fixColpi(video) {
    const a = video.data[2].entries;
    let fixed = [
      {
        time: 0,
        label: "",
      },
    ];
    //debugger;
    for (let x = 0; x < a.length; x++) {
      if (!Tracking.fixedMeta) {
        const stroke = a[x];
        if (stroke.type === "backhand") {
          Tracking.fixedMeta = true;

          Meta.indicators["backhand_two-handed"] = Meta.indicators.backhand["two-handed"];
          Meta.indicators["backhand_one-handed"] = Meta.indicators.backhand["one-handed"];
          delete Meta.indicators["backhand"];

          if (stroke.stroke_props.subtype === "two-handed") {
            Meta.indicators["backhand"] = Meta.indicators["backhand_two-handed"];
          } else {
            Meta.indicators["backhand"] = Meta.indicators["backhand_one-handed"];
          }
        }
      }

      fixed = fixed.concat(this.fixPhases(a[x].fasi, a[x], video.data[5]));
    }
    video.data[2] = fixed;
    video.data.push(this.createStats(a, video.data[3]));

    //console.log(fixed);
    //console.log(video.data);
  }

  fixPhases(phases, stroke, stats) {
    const ret = [];
    for (let x = 0; x < phases.length; x++) {
      if (phases[x].time > 0) {
        ret.push({
          stroke: this.addDetails(stroke, phases[x], stats),
          time: Math.floor(phases[x].time * 1000),
          label: phases[x].label,
          startStroke: x === 0,
          endStroke: x === phases.length - 1,
          hiddenBar: x === 1,
        });
      }
    }
    return ret;
  }

  addDetails(stroke, fase, stats) {
    let data;
    for (let x = 0; x < stats.length; x++) {
      if (stats[x]) {
        if (stats[x].uid === stroke.uid) {
          data = stats[x];
          break;
        }
      }
    }
    if (data) {
      /*console.log(stroke);
      console.log(fase);
      console.log(data);*/
      for (let prop in data) {
        if (data[prop].uid === fase.uid) {
          fase.stats = data[prop];
          fase.erroriTotali = this.calcolaErrori(fase.stats);
          let count = 0;
          for (let prop1 in fase.stats) {
            count++;
          }
          fase.noData = false;
          if (count <= 1) {
            fase.noData = true;
          }

          fase.colpoNonValido = false;
          break;
        }
      }
    } else {
      fase.stats = {};
      fase.erroriTotali = 0;
      fase.colpoNonValido = true;
    }
    return stroke;
  }

  fixStats(video) {
    const db = video.data[2].entries;
    const a = video.data[5];
    let fixed = [];
    for (let x = 0; x < a.length; x++) {
      //console.log(a[x]);
      fixed = fixed.concat(this.fixStatsColpo(db, a[x]));
    }
    //video.data[5] = fixed;
    fixed = this.shpalma(fixed);
    //console.log(fixed);
    video.data[5] = fixed;
  }

  fixStatsColpo(db, colpo) {
    const ret = [];
    const colpoRef = this.getColpoById(db, colpo.uid);
    /*console.log("----------------");
    console.log(colpo);
    console.log(colpoRef);*/

    let aref = colpoRef.fasi.slice();
    // sorta aref sulla proprietà time (dovrebbe essere già ordinato ma così è più sicuro)
    aref.sort(function (a, b) {
      return a.time - b.time;
    });
    // Per ogni fase controlla se esiste nel colpo
    for (let x = 0; x < aref.length; x++) {
      let det;
      let lFound = false;
      for (let prop in colpo) {
        if (colpo[prop].uid === aref[x].uid) {
          det = colpo[prop];
          lFound = true;
          break;
        }
      }
      if (lFound) {
        //console.log(det);
        let collector = [];

        let n = 0;
        for (let prop1 in det) {
          if (prop1 !== "uid") {
            if (det[prop1]) {
              n = det[prop1].length;
            }
          }
        }
        //console.log(n);
        for (let x = 0; x < n; x++) {
          let o = {};
          for (let prop1 in det) {
            if (prop1 !== "uid") {
              if (det[prop1]) {
                o[prop1] = det[prop1][x];
              }
            }
          }
          collector.push(o);
        }

        //debugger;
        /*for (let prop1 in det) {
          if (prop1 !== "uid") {
            //debugger;
            if (det[prop1]) {
              for (let y = 0; y < det[prop1].length; y++) {
                let o = {};
                if (collector[n] !== undefined) {
                  o = collector[n];
                } else {
                  collector.push(o);
                }
                o[prop1] = det[prop1][y];
              }
            }
            //debugger;
            n++;
          }
        }*/
        if (collector.length > 0) {
          let oo = [];
          oo.push(aref[x].label);
          oo.push(collector);
          oo.push(aref[x].time);
          ret.push(oo);
        }
      }
    }

    //console.log(aref);

    return ret;
  }

  getColpoById(db, id) {
    for (let x = 0; x < db.length; x++) {
      if (db[x].uid === id) {
        return db[x];
      }
    }
    return null;
  }

  shpalma(a) {
    //
    let ret = [];
    // Primo elemento
    let time = a[0][2];
    let frames = Math.floor(MainScene.FPS * time) - 1; //- 2;
    for (let x = 0; x < frames; x++) {
      ret.push([null, {}]);
    }
    //debugger;
    for (let x = 0; x < a.length; x++) {
      let frameStart = Math.floor(MainScene.FPS * a[x][2]);
      while (ret.length < frameStart) {
        ret.push([null, {}]);
      }
      for (let y = 0; y < a[x][1].length; y++) {
        ret.push([a[x][0], a[x][1][y]]);
      }
    }

    return ret;
  }

  calcolaErrori(a) {
    let totalErrors = 0;
    for (let prop in a) {
      if (typeof a[prop] !== "string") {
        //console.log(prop);
        if (a[prop] && a[prop].signed_errors) {
          const err = a[prop].signed_errors;
          for (let x = 0; x < err.length; x++) {
            if (err[x] !== 0) {
              totalErrors++;
              break;
            }
          }
        }
      }
    }
    //console.log(totalErrors);
    return totalErrors;
  }

  static getMeta(prop, type, label) {
    /*    console.log(prop);
    if (prop === "wri_nd_x") {
      debugger;
    }*/

    let ret = {
      prop: prop,
      name: prop,
      desc: prop,
      unit: "°",
      order: -1,
      showsign: false,
    };
    const o = Meta.indicators;

    for (let prop0 in o) {
      if (prop0 === type) {
        //
        for (let prop1 in o[prop0]) {
          if (prop1 === label) {
            for (let prop2 in o[prop0][prop1]) {
              if (prop2 === prop) {
                const tmp = o[prop0][prop1][prop2];
                //debugger;
                const locale = Pqp.safeReplace(TheApp.Locale, "-", "_");
                ret = {
                  prop: prop,
                  name: tmp.name[locale] !== "" ? tmp.name[locale] : prop,
                  desc: tmp.description[locale] !== "" ? tmp.description[locale] : prop,
                  solution: tmp.solution && tmp.solution[locale] !== "" ? tmp.solution[locale] : "",
                  order: tmp.order,
                  unit: tmp.unit,
                  showsign: tmp.showsign ? true : false,
                };
                return ret;
              }
            }
          }
        }
      }
    }
    return ret;
  }

  createStats(data, ballVelocity) {
    //    debugger;
    const ret = {};
    for (let x = 0; x < data.length; x++) {
      const stroke = data[x];
      const fasi = stroke.fasi;
      for (let y = 0; y < fasi.length; y++) {
        const fase = fasi[y];
        const appiattita = this.appiattisci(stroke, fase);
        //debugger;
        //console.log(appiattita);
        for (let z = 0; z < appiattita.length; z++) {
          const frame = "f" + appiattita[z].frame;
          ret[frame] = appiattita[z];
        }
      }
    }

    //console.log(ret);
    // Crea la velocità della palla
    return ret;
  }

  appiattisci(stroke, fase) {
    //debugger;
    const ret = [];
    const a = fase.stats;
    // Prima calcola il numero di frame start e end
    //let fstart = 10000000000000;
    let fstart = fase.frameTime;
    let fend = 0;
    let propNum = 0;
    this.vlines = [];

    //debugger;

    for (let prop in a) {
      if (typeof a[prop] !== "string") {
        if (a[prop]) {
          propNum++;
          const el = a[prop];
          if (el.frame_start < fstart) {
            fstart = el.frame_start;
          }
          const calcfend = el.frame_start + el.signed_errors.length;
          if (calcfend > fend) {
            fend = calcfend;
          }
        }
      }
    }

    const cmp = stroke.fasi;
    for (let i = 0; i < cmp.length; i++) {
      if (cmp[i].uid === fase.uid) {
        if (cmp[i + 1]) {
          fend = cmp[i + 1].frameTime;
        }
      }
    }

    //debugger;
    let points = [];
    for (let prop in a) {
      if (typeof a[prop] !== "string") {
        if (a[prop]) {
          const meta = Tracking.getMeta(prop, stroke.type, fase.label);
          //console.log(meta.showsign);
          //          debugger;
          points.push(this.createDataPoints(meta, a[prop], fstart, fend));
        }
      }
    }

    /*    for (let x=0;x<points.length;x++) {
      const o = {
        frame: points[x].frame,
        data:[]
      }
      for (let y=0;y)
    }*/

    let tmp = points[0];
    if (tmp) {
      for (let x = 0; x < tmp.length; x++) {
        const o = {
          frame: tmp[x].frame,
          data: [],
        };
        for (let y = 0; y < points.length; y++) {
          o.data.push(points[y][x]);
        }
        ret.push(o);
      }
    }
    //debugger;

    return ret;
  }

  createDataPoints(meta, datas, fstart, fend) {
    const ret = [];
    const errors = datas.signed_errors;
    const values = datas.values;
    /*if (meta.prop === "arm_abd") {
      debugger;
    }*/
    //debugger;

    for (let i = fstart; i < fend; i++) {
      let type = 0;
      let err = "";
      if (i >= datas.frame_start && i < datas.frame_start + errors.length) {
        if (errors[i - fstart - (datas.frame_start - fstart)] !== 0) {
          err = errors[i - fstart - (datas.frame_start - fstart)].toFixed(2);
          type = 1;
        } else {
          type = 2;
        }
      }

      ret.push({
        meta: meta,
        frame: i,
        //value: values[i - fstart],
        value: values[i - fstart - (datas.frame_start - fstart)],
        //valuePrint: values[i - fstart] ? values[i - fstart].toFixed(2) + meta.unit : "",
        valuePrint: values[i - fstart - (datas.frame_start - fstart)] ? values[i - fstart - (datas.frame_start - fstart)].toFixed(2) + meta.unit : "",
        type: type,
        max_t: datas.max_t,
        min_t: datas.min_t,
        max_t_print: datas.max_t || datas.max_t === 0 ? datas.max_t.toFixed(0) + meta.unit : "none",
        min_t_print: datas.min_t || datas.min_t === 0 ? datas.min_t.toFixed(0) + meta.unit : "none",
        origin: datas,
      });

      if (ret[ret.length - 1].max_t_print === "none" && ret[ret.length - 1].min_t_print === "none") {
        ret[ret.length - 1].max_t_print = "";
        ret[ret.length - 1].min_t_print = "";
      }

      if (ret[ret.length - 1].max_t_print === "none") {
        ret[ret.length - 1].max_t_print = "";
        ret[ret.length - 1].min_t_print = ">" + ret[ret.length - 1].min_t_print;
      }
      if (ret[ret.length - 1].min_t_print === "none") {
        ret[ret.length - 1].min_t_print = "";
        ret[ret.length - 1].max_t_print = "<" + ret[ret.length - 1].max_t_print;
      }

      const o = ret[ret.length - 1];
      if (meta.showsign) {
        if (o.value > 0) {
          o.valuePrint = "+" + o.valuePrint;
        }
      }

      //debugger;
      //console.log(meta.showsign);

      if (err !== "") {
        //console.log(err);

        if (err.indexOf("-") === -1) {
          ret[ret.length - 1].valuePrint = ret[ret.length - 1].valuePrint + " (+" + err + meta.unit + ")";
        } else {
          ret[ret.length - 1].valuePrint = ret[ret.length - 1].valuePrint + " (" + err + meta.unit + ")";
        }
      }
    }
    return ret;
  }

  fixAggregates(data, strokes, base) {
    //console.log(data);
    // Prende solo il nodo interessato in base al tipo di colpo

    let type;
    for (let x = 0; x < strokes.length; x++) {
      if (strokes[x].stroke) {
        type = strokes[x].stroke.type;
        break;
      }
    }
    if (!Pqp.isNullOrEmpty(type)) {
      //console.log(type);
      const ret = {};
      for (let prop in data) {
        if (prop === type) {
          ret[prop] = this.preparaPerReport(prop, data[prop]);
        }
      }
      ret.current = ret[type];
      ret.current.strokeType = type;
      console.log(ret);
      base.report = ret;
    } else {
      base.report = null;
    }
  }

  preparaPerReport(strokeType, data) {
    //console.log(strokeType);
    let ret = [];
    for (let prop in data) {
      ret.push(this.preparaPerReportSingolaFase(prop, strokeType, data[prop]));
    }
    // Ordina ogni roba dentro per priorit
    for (let x = 0; x < ret.length; x++) {
      ret[x].indicators.sort(function (a, b) {
        return b.priority - a.priority;
      });
    }

    return ret;
  }

  preparaPerReportSingolaFase(fase, strokeType, data) {
    const el = {};
    el.fase = fase;
    el.indicators = [];
    //console.log(fase);
    //console.log(data);
    let lErrors = false;
    for (let prop in data) {
      // Decripta la prop
      const entry = {};
      const o = Tracking.getMeta(prop, strokeType, fase);
      //console.log(o);
      entry.meta = o;
      const tmp = data[prop];
      entry.original = tmp;
      if (tmp) {
        entry.priority = tmp.priority;
        entry.valid = true;
        if (tmp.strokes_count > 0) {
          lErrors = true;
          entry.errors = tmp.strokes_count;
          entry.hasErrors = true;
          entry.mediaErrore = tmp.absolute_constant_error.toFixed(2) + entry.meta.unit;
          if (tmp.variable_error !== 0) {
            entry.deviazioneStandard = tmp.variable_error.toFixed(2) + entry.meta.unit;
          } else {
            entry.deviazioneStandard = 0;
          }
        } else {
          entry.hasErrors = false;
        }
      } else {
        entry.priority = 0;
        entry.valid = false;
      }
      el.indicators.push(entry);
    }
    if (lErrors) {
      el.hasErrors = true;
    } else {
      el.hasErrors = false;
    }
    //ret.push(el);

    return el;
  }
}

Tracking.appConfig = null;
Tracking.data = [];
Tracking.WIDTH = 1920;
Tracking.HEIGHT = 1080;
Tracking.FILES = null;
Tracking.STROKE_COLOR = "#00daff";
Tracking.STROKE_INTENSITY = 1;

Tracking.DEBUG_PAOLO = false;
Tracking.ALPHA_PANEL = 0.6;
//Tracking.REDDONE = 0xff2400;
//Tracking.REDDONE = 0xff4c4c;
Tracking.REDDONE = 0xffa500;
